import { useEffect, useRef } from 'react';

interface Props {
  time: number;
  updateTime: (updateState?: boolean) => void;
  render?: (counter: number) => JSX.Element;
  onComplete?: () => void;
}

const Countdown = ({ time, updateTime, render, onComplete }: Props) => {
  const timerRef = useRef<ReturnType<typeof setInterval>>();
  const hasCompletedRef = useRef(false);

  useEffect(() => {
    if (time <= 0) {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = undefined;
      }

      if (!hasCompletedRef.current) {
        hasCompletedRef.current = true;
        onComplete?.();
      }

      return undefined;
    }

    hasCompletedRef.current = false;

    if (!timerRef.current) {
      timerRef.current = setInterval(() => {
        updateTime();
      }, 1000);
    }
    return () => {
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = undefined;
      }
    };
  }, [time, updateTime, onComplete]);

  if (render) return render(time);
  return <span>{time}</span>;
};

export default Countdown;
